import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import { ApplicationService } from '../../service/ApplicationService';
import { translatedMessage } from '../../service/LanguageService';
import GeneralUtils from '../../utilities/GeneralUtils';
import { Button } from 'primereact/button';


const UserApplicationPublicServant = (props) => {
    const [application, setApplication] = useState([]);

    const toast = useRef(null);

    const applicationService = useMemo(() => new ApplicationService(), []);

    useEffect(() => {
        setApplication(props?.application);
    }, [props])

    const publicServantCheck = async () => {
        await applicationService.publicServantCheck(props?.application.id)
            .then((response) => {
                // console.log("Public Servant status changed from " + _application.user.profilePublicServant + " to " + response);
                let _application = {
                    ...application,
                    user: {
                        ...application.user,
                        profilePublicServant: response.publicServant,
                        profilePublicServantLastUpdatedOn: response.publicServantLastUpdatedOn
                    }
                }

                setApplication(_application);

                if (typeof props.afterCheck === 'function') {
                    props.afterCheck(_application);
                }
                toast?.current?.show({ severity: 'success', summary: translatedMessage('user.publicServant.status.check.success'), life: 5000 });
            })
            .catch((error) => toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }))
    }

    return (
        <>
            <Toast ref={toast} />
            <div className="flex align-items-center mt-5 mb-0">
                <h3 className='mb-0 mt-0 mr-2'>
                    {translatedMessage('user.publicServant.status') + ": "}
                </h3>
                <h3 className='mb-0 mt-0 fw-400 mr-2'>{GeneralUtils.yesNoConverter(application?.user?.profilePublicServant)}</h3>
                <Button
                    className="p-button p-button-primary m-1"
                    onClick={publicServantCheck}
                    label={translatedMessage('user.publicServant.status.check')}
                    icon="pi pi-check"
                    tooltip={translatedMessage('user.publicServant.status.lastCheck') + ": " + GeneralUtils.formatDateTime(application?.user?.profilePublicServantLastUpdatedOn)}
                    tooltipOptions={{ position: 'top' }}                    
                />
            </div>


        </>
    );
};

export default UserApplicationPublicServant;
